// extracted by css-extract-rspack-plugin
export default {"card":"ZLLou","cardSelected":"jKqto"};